import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "@/components/ui/button";
import { Eraser } from "@phosphor-icons/react";

export const SignaturePadField = ({ onChange }) => {
  const ref = useRef(null);
  const [empty, setEmpty] = useState(true);

  const clear = () => {
    ref.current?.clear();
    setEmpty(true);
    onChange?.(null);
  };

  const handleEnd = () => {
    if (!ref.current) return;
    if (ref.current.isEmpty()) {
      setEmpty(true);
      onChange?.(null);
    } else {
      // NOTE: getTrimmedCanvas() throws "trim_canvas is not a function" due to
      // an ESM/CJS interop bug in react-signature-canvas + trim-canvas.
      // Use the raw canvas via getCanvas() instead — backend accepts any PNG.
      const canvas = ref.current.getCanvas
        ? ref.current.getCanvas()
        : ref.current.getSignaturePad?.()?.canvas;
      const dataUrl = canvas
        ? canvas.toDataURL("image/png")
        : ref.current.toDataURL("image/png");
      setEmpty(false);
      onChange?.(dataUrl);
    }
  };

  return (
    <div className="space-y-3">
      <div className="sig-canvas overflow-hidden" data-testid="signature-canvas-wrap">
        <SignatureCanvas
          ref={ref}
          onEnd={handleEnd}
          penColor="#0f172a"
          canvasProps={{
            width: 800,
            height: 220,
            className: "w-full h-[180px] sm:h-[220px]",
            "data-testid": "signature-canvas",
          }}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="text-xs text-slate-500">
          {empty ? "Bitte hier mit dem Finger oder der Maus unterschreiben." : "Unterschrift erfasst."}
        </p>
        <Button
          variant="ghost"
          size="sm"
          onClick={clear}
          className="text-slate-600 hover:text-slate-900"
          data-testid="signature-clear"
        >
          <Eraser size={16} className="mr-1" /> Löschen
        </Button>
      </div>
    </div>
  );
};

export default SignaturePadField;
